export const validatePassword = (password) => {
  const errors = []
  
  if (password.length < 12) {
    errors.push('يجب أن تكون 12 حرف على الأقل')
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('يجب أن تحتوي على حرف كبير')
  }
  if (!/[a-z]/.test(password)) {
    errors.push('يجب أن تحتوي على حرف صغير')
  }
  if (!/[0-9]/.test(password)) {
    errors.push('يجب أن تحتوي على رقم')
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('يجب أن تحتوي على رمز خاص (!@#$...)')
  }
  
  const commonPasswords = [
    'password', '123456', 'qwerty', '12345678',
    'password123', 'admin', 'letmein'
  ]
  if (commonPasswords.includes(password.toLowerCase())) {
    errors.push('كلمة مرور شائعة جداً - استخدم كلمة أقوى')
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    strength: calculateStrength(password)
  }
}

function calculateStrength(password) {
  let strength = 0
  if (password.length >= 12) strength++
  if (password.length >= 16) strength++
  if (/[A-Z]/.test(password)) strength++
  if (/[a-z]/.test(password)) strength++
  if (/[0-9]/.test(password)) strength++
  if (/[!@#$%^&*]/.test(password)) strength++
  
  if (strength <= 2) return 'ضعيفة'
  if (strength <= 4) return 'متوسطة'
  return 'قوية'
}
